import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJava,
  DiPython,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiHtml5,
  DiCss3,
  DiGit,
  DiAngularSimple,
} from "react-icons/di";
import {
  SiSpring,
  SiFlask
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function VersionControl() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="GIT">
        <DiGit />
      </Col>

    </Row>
  );
}

export default VersionControl;
